import axios from "axios";
import { DELIVRY_NOTE_LIST_FAIL, DELIVRY_NOTE_LIST_REQUEST, DELIVRY_NOTE_LIST_SUCCESS } from "../constats/delivry_note.constant";
import { logout } from "./auth.action";
import { endpointApi } from "../../utils";

export const getDelivryNotes = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: DELIVRY_NOTE_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }delivry-notes${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: DELIVRY_NOTE_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: DELIVRY_NOTE_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: DELIVRY_NOTE_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}